import { Heading, HeadingProps } from '@chakra-ui/react';

export interface CustomHeadingProps extends HeadingProps {
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  isAllCaps?: boolean;
}

const CustomHeading = (props: CustomHeadingProps) => {
  const { children, level = 'h2' } = props;
  const { isAllCaps, ...otherProps } = props;

  const getDefaultSizes = () => {
    if (isAllCaps) {
      switch (level) {
        case 'h1':
          return {
            fontSize: 'xl',
            lineHeight: 7,
            mb: 4,
          };
        case 'h2':
          return {
            fontSize: 'lg',
            lineHeight: 6,
            mb: 2,
          };
        case 'h3':
          return {
            fontSize: 'md',
            lineHeight: 5,
            mb: 2,
          };
        case 'h4':
          return {
            fontSize: 'sm',
            lineHeight: 4,
            mb: 1,
          };
        case 'h5':
          return {
            fontSize: 'xs',
            lineHeight: 4,
            mb: 1,
          };
        case 'h6':
          return {
            fontSize: '2xs',
            lineHeight: 3,
            mb: 0,
          };
      }
    } else {
      switch (level) {
        case 'h1':
          return {
            fontSize: { base: '3xl', md: '4xl' },
            lineHeight: { base: 8, md: 10 },
            mb: { base: 4, md: 6 },
          };
        case 'h2':
          return {
            fontSize: { base: '2xl', md: '3xl' },
            lineHeight: { base: 7, md: 8 },
            mb: { base: 4, md: 5 },
          };
        case 'h3':
          return {
            fontSize: { base: 'xl', md: '2xl' },
            lineHeight: { base: 6, md: 7 },
            mb: { base: 3, md: 4 },
          };
        case 'h4':
          return {
            fontSize: 'lg',
            lineHeight: 6,
            mb: 2,
          };
        case 'h5':
          return {
            fontSize: 'md',
            lineHeight: 5,
            mb: 1,
          };
        case 'h6':
          return {
            fontSize: 'sm',
            lineHeight: 4,
            mb: 0,
          };
      }
    }
  };

  const sizeProps = getDefaultSizes();

  return (
    <Heading as={level} variant={isAllCaps ? 'allcaps' : undefined} {...sizeProps} {...otherProps}>
      {children}
    </Heading>
  );
};

export { CustomHeading };
